<template>
  <div>
    <p class="pb-6">{{ instructions }}</p>

    <div class="grid gap-2 rounded-lg bg-gray-100 p-6 shadow">
      <div class="text-center font-bold">Provider</div>
      <div class="text-center">{{ providerKey }}</div>
      <template v-if="!isView">
        <div class="text-center font-bold">Component</div>
        <div class="text-center">{{ component }}</div>
      </template>
      <template v-if="isView">
        <div class="text-center font-bold">Route Name</div>
        <div class="text-center">{{ route.name }}</div>
      </template>
      <template v-if="isView">
        <div class="text-center font-bold">Route Path</div>
        <div class="text-center">{{ route.path }}</div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from "vue"
  import { useCurrentProvider } from "@versatile-credit-apply/composition"
  import { useRoute } from "vue-router"

  type Props = {
    component?: string
    provider?: string | null
  }

  const props = withDefaults(defineProps<Props>(), {
    component: "View",
    provider: null,
  })

  const route = useRoute()

  const currentProviderKey = useCurrentProvider()

  const isView = computed(() => {
    return props.component === "View"
  })

  const providerKey = computed(() => {
    return (
      props.provider || route.params.providerKey || currentProviderKey.value
    )
  })

  const instructions = computed(() => {
    if (isView.value) {
      return "Please override this view with a provider specific view."
    } else {
      return "Please override this component with a provider specific component."
    }
  })
</script>
